import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { flushSync } from "react-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import CompassLayout from "@/components/compass/CompassLayout";
import { useCompass } from "@/context/CompassContext";

export default function CompassCountry() {
  const nav = useNavigate();
  const { draft, update } = useCompass();
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!draft.path) { nav("/brujula", { replace: true }); return; }
    api.get("/compass/geo")
      .then((r) => setCountries(r.data.countries || []))
      .catch(() => toast.error("No se pudo cargar la lista de países"))
      .finally(() => setLoading(false));
  }, [draft.path, nav]);

  const choose = (name) => {
    flushSync(() => update({ country: name, state: null, city: null }));
    nav("/brujula/ciudad");
  };

  return (
    <CompassLayout back="/brujula" step={1} total={4} testid="page-compass-country">
      <div className="mb-6">
        <div className="label-mono text-muted-foreground">Paso 1 de 4</div>
        <h1 className="display text-3xl md:text-4xl mt-2 leading-[1]">
          ¿Dónde estás?
        </h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Las regulaciones, proveedores y oportunidades cambian según tu país.
        </p>
      </div>

      {loading && <div className="text-sm text-muted-foreground">Cargando…</div>}

      <div className="grid grid-cols-2 gap-3">
        {countries.map((c) => (
          <button
            key={c.name}
            onClick={() => choose(c.name)}
            data-testid={`country-${c.code}`}
            className={`bg-surface border-2 border-foreground p-4 flex flex-col items-start gap-2 transition-transform hover:-translate-x-[2px] hover:-translate-y-[2px] shadow-[3px_3px_0_0_hsl(var(--foreground))] hover:shadow-[5px_5px_0_0_hsl(var(--foreground))] ${
              draft.country === c.name ? "bg-foreground text-background" : ""
            }`}
          >
            <span className="text-4xl leading-none" aria-hidden>{c.flag}</span>
            <span className="display text-lg leading-tight">{c.name}</span>
          </button>
        ))}
      </div>
    </CompassLayout>
  );
}
